(() => {
  const ELEMENT_NAME = 'toffee-pdp-bundle-cta';

  if (customElements.get(ELEMENT_NAME)) return;

  class ToffeePdpBundleCta extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-toffee-pdp-bundle-link]');
      if (!this.link) return;

      this.prefillProduct = this.dataset.prefillProduct !== 'false';
      this.link.addEventListener('click', () => this.updateDestination());
      this.updateDestination();
    }

    updateDestination() {
      const form = document.getElementById(this.dataset.productFormId || '');
      const variantInput = form?.querySelector('[name="id"]')
        || document.querySelector(`[name="id"][form="${CSS.escape(this.dataset.productFormId || '')}"]`);
      const variantId = Number.parseInt(variantInput?.value, 10);

      try {
        const url = new URL(this.link.href, window.location.origin);
        if (this.prefillProduct) {
          if (Number.isSafeInteger(variantId) && variantId > 0) {
            url.searchParams.set('toffee_bundle_variant', String(variantId));
          }
          url.searchParams.set('toffee_bundle_product', this.dataset.productHandle || '');
        } else {
          url.searchParams.delete('toffee_bundle_variant');
          url.searchParams.delete('toffee_bundle_product');
        }

        const currentUrl = new URL(window.location.href);
        const previewThemeId = currentUrl.searchParams.get('preview_theme_id');
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

        this.link.href = url.toString();
      } catch (error) {
        // The server-rendered destination remains a functional fallback.
      }
    }
  }

  customElements.define(ELEMENT_NAME, ToffeePdpBundleCta);
})();

